export default status => {
  if (status === 'ACTIVE') {
    return '#EAEBFF';
  } if (status === 'SOLD_OUT') {
    return '#ffe0b1';
  } return '#e2e2e2';
};
